import { z } from "zod";
import { Id } from "../common/ids.js";
import { Timestamp } from "../common/time.js";
import { MessageEntry } from "./message.routes.js";
/**
 * What the platform publishes on a membership's personal channel once a write commits (ADR 0029 section 5, card 157).
 * Live delivery is a hint: each message carries a number, so applying it twice changes nothing, and a client that
 * missed one repairs by sequence number and the inbox. A client ignores a type or a version it does not know.
 */
export const LiveEntry = z
    .object({
    v: z.literal(1),
    type: z.literal("entry"),
    conversationId: Id,
    seq: z.number().int().positive(),
    entry: MessageEntry,
})
    .describe("An entry appended to the conversation's log, as its history shows it");
export const LiveRead = z
    .object({
    v: z.literal(1),
    type: z.literal("read"),
    conversationId: Id,
    userId: Id,
    readSeq: z.number().int().nonnegative(),
})
    .describe("How far a member has now read: receipts for the others, and the reader's other devices");
export const LiveMembership = z
    .object({
    v: z.literal(1),
    type: z.literal("membership"),
    conversationId: Id,
    membership: z.literal("left"),
})
    .describe("The receiving membership is out of the conversation, removed, left, or replaced; its client deletes it");
export const LiveConversation = z
    .object({
    v: z.literal(1),
    type: z.literal("conversation"),
    conversationId: Id,
    changedAt: Timestamp.describe("The inbox time the change took: the newer wins"),
    settings: z.object({ pinnedAt: Timestamp.nullable(), mutedUntil: Timestamp.nullable() }),
})
    .describe("The receiving person's own settings for the conversation changed, on another of their devices (card 158)");
export const LiveMessage = z.discriminatedUnion("type", [
    LiveEntry,
    LiveRead,
    LiveMembership,
    LiveConversation,
]);
//# sourceMappingURL=live-messages.js.map